import type { IGameSetSession } from '@core/game-set';

const ROUND_TRACE_PREFIX = '[MahjongKing][RoundTrace]';

export const traceGameSet = (
  event: string,
  session: IGameSetSession | null,
  detail: Record<string, unknown> = {},
  balances?: readonly [number, number, number, number]
): void => {
  const plan = session?.currentRound ?? null;
  console.info(
    `${ROUND_TRACE_PREFIX} ${JSON.stringify({
      timestamp: new Date().toISOString(),
      event,
      session: session
        ? {
            sessionId: session.sessionId,
            roundId: plan?.roundId ?? null,
            transactionId: plan?.transactionId ?? null,
            sessionStatus: session.status,
            completionReason: session.completionReason,
            prevailingWind: plan?.prevailingWind ?? session.prevailingWind,
            roundIndex: plan?.roundIndex ?? session.roundIndex,
            dealerSeat: plan?.dealerSeat ?? session.dealerSeat,
            dealerStreak: plan?.dealerStreak ?? session.dealerStreak,
            fakeEastSeat: session.fakeEastSeat,
            openingSeat: plan?.openingSeat ?? null,
            seatWinds: plan?.seatWinds ?? null,
            dealerDice: plan?.dealerDice ?? null,
            openingDice: plan?.openingDice ?? null,
            wallSeed: plan?.wallSeed ?? null,
            base: plan?.base ?? session.bet.base,
            taiUnit: plan?.taiUnit ?? session.bet.taiUnit,
            balances: balances ?? null,
            settlementApplied: plan?.settlementApplied ?? null,
            liveWallRemaining: null,
            deadWallCount: null,
            completedKongCount: null,
            nextDealerSeat: plan ? null : session.dealerSeat,
            nextDealerStreak: plan ? null : session.dealerStreak,
          }
        : null,
      detail,
    })}`
  );
};
